import React from 'react';
import { Box, Typography } from '@mui/material';
import { BillingAndInvoiceProvider } from '../../../contexts/BillingAndInvoiceContext';
import InvoiceList from '../billings/InvoiceList';

/**
 * Billing & Invoice tab content for the Subscription hub.
 * Self-serve: invoices, payment links, and payment history live here.
 */
function SubscriptionBillingContent() {
  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Billing & Invoices
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage your invoices and payment history
        </Typography>
      </Box>
      <InvoiceList />
    </Box>
  );
}

export default function SubscriptionBilling() {
  return (
    <BillingAndInvoiceProvider>
      <SubscriptionBillingContent />
    </BillingAndInvoiceProvider>
  );
}
